<template>
  <v-menu offset-y bottom :close-on-content-click="false" v-if="nextWorkflowStatus.length > 1">
    <template v-slot:activator="{ on, attrs }">
      <slot :attrs="attrs" :on="on" />
    </template>

    <v-list>
      <ActionNextWorkflowButton
        v-for="workflowStatus in initialStatus"
        :key="workflowStatus.id"
        :attendance="attendance"
        :nextWorkflowStatus="workflowStatus"
        :startAttendance="startAttendance"
        noTooltip
        v-slot:default="{ clickEvent, on, attrs, moreOptions, actionName }"
      >
        <v-list-item :attrs="attrs" v-on="on" @click="clickEvent">
          <v-list-item-title>
            {{ actionName }}
          </v-list-item-title>

          <v-list-item-action>
            <v-icon v-if="moreOptions">eva-chevron-right-outline</v-icon>
          </v-list-item-action>
        </v-list-item>
      </ActionNextWorkflowButton>

      <v-divider />

      <ActionNextWorkflowButton
        v-for="workflowStatus in noInitialStatus"
        :key="workflowStatus.id"
        :attendance="attendance"
        :nextWorkflowStatus="workflowStatus"
        :startAttendance="startAttendance"
        noTooltip
        v-slot:default="{ clickEvent, on, attrs, moreOptions, actionName }"
      >
        <v-list-item :attrs="attrs" v-on="on" @click="clickEvent">
          <v-list-item-title>
            {{ actionName }}
          </v-list-item-title>

          <v-list-item-action>
            <v-icon v-if="moreOptions">eva-chevron-right-outline</v-icon>
          </v-list-item-action>
        </v-list-item>
      </ActionNextWorkflowButton>
    </v-list>
  </v-menu>

  <ActionNextWorkflowButton
    v-else
    v-show="firstNextWorkflowStatus"
    :attendance="attendance"
    :nextWorkflowStatus="firstNextWorkflowStatus"
    :startAttendance="startAttendance"
    v-slot:default="{ clickEvent, on, attrs }"
  >
    <slot :attrs="attrs" :on="on" :clickEvent="clickEvent" />
  </ActionNextWorkflowButton>
</template>

<script>
  import ActionNextWorkflowButton from "@/components/queues/attendance/actions/next_workflow_button.vue";

  export default {
    name: "ActionNextWorkflow",
    props: {
      attendance: Object,
      nextWorkflowStatus: Array,
      startAttendance: Function,
    },
    components: {
      ActionNextWorkflowButton,
    },
    data() {
      return {
        menuOpened: false,
      };
    },
    computed: {
      firstNextWorkflowStatus() {
        return this.lodash.first(this.nextWorkflowStatus);
      },
      initialStatus() {
        return this.lodash.filter(this.nextWorkflowStatus, (e) => e.initial);
      },
      noInitialStatus() {
        return this.lodash.filter(this.nextWorkflowStatus, (e) => !e.initial);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
